import dateFns from 'date-fns'

// import { randomIntFromInterval } from '../../utils/random'
import AppPage from '../../mixins/app-page'

import AppTitle from '../app-title'
import AppImgBg from '../app-img-bg'
import AppBtn from '../app-btn'
import AppBtnFilter from '../app-btn-filter'
import AppBtnRadio from '../app-btn-radio'
import AppMatchesTableTr from '../app-matches-table-tr'
import AppSeasonComingSoon from '../app-season-coming-soon'


const UPCOMING = 'upcoming'
const TODAY = 'today'
const PAST = 'past'


export default
{
    name: 'page-matches',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppTitle,
        AppImgBg,
        AppBtn,
        AppBtnFilter,
        AppBtnRadio,
        AppMatchesTableTr,
        AppSeasonComingSoon
    },

    data()
    {
        return {
            days: [],
            filterDay: TODAY,
            filterVideoGame: [],
            filterBackground: '/static/bg/bg-counter-strike-global-offensive.jpg',
            games: this.contentGlobal.videoGames
        }
    },

    created()
    {
        const filter = this.params.filter
        if (filter)
        {
            const gameId = this.games.find(game => game.slug === filter).id
            this.filterVideoGame = [gameId]
        }
        for (let i = 0, l = this.games.length; i < l; i += 1)
        {
            this.filterVideoGame.push(i + 1)
        }
    },

    mounted()
    {
        if (this.contentPage.list.length > 0)
        {
            this.eventHub.$emit('bg-change', this._getBackground())
        }
        else
        {
            this.eventHub.$emit('bg-change', '/static/bg/bg-coming-soon.jpg')
        }

        if (this._getNumMatches(TODAY) > 0)
        {
            this._onFilterDateToday()
        }
        else if (this._getNumMatches(UPCOMING) > 0)
        {
            this._onFilterDateUpcoming()
        }
        else
        {
            this._onFilterDatePast()
        }
    },

    methods:
    {
        toggleGame(id)
        {
            if (this.filterVideoGame.includes(id))
            {
                this.filterVideoGame.splice(this.filterVideoGame.indexOf(id), 1)
            }
            else
            {
                this.filterVideoGame.push(id)
            }

            const tmp = this.filterVideoGame
            this.filterVideoGame = []

            this.$nextTick(() =>
            {
                this.filterVideoGame = tmp

                this.filterMatches(this.filterDay)
            })
        },

        _getDateFilter(when)
        {
            let filter
            const now = new Date()

            switch (when)
            {
            case PAST : {
                const dateOut = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
                filter = [0, (dateOut.getTime() - 1000) / 1000]
                break
            }
            case TODAY : {
                const dateIn = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
                const dateOut = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
                filter = [dateIn.getTime() / 1000, dateOut.getTime() / 1000]
                break
            }
            case UPCOMING : {
                const dateIn = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
                filter = [(dateIn.getTime() + 1000) / 1000, Infinity]
                break
            }
            default :
                console.error('<page-matches> ' + when + ' don’t exist')
                break
            }

            return filter
        },

        _getNumMatches(when)
        {
            const filter = this._getDateFilter(when)
            const matchesJSON = JSON.parse(JSON.stringify(this.contentPage.list))
            const matches = matchesJSON.filter(match =>
                match.dateStart >= filter[0]
                && match.dateStart <= filter[1])

            return matches.length
        },

        load()
        {
            this.$emit('load', this)
        },

        openModalRegister()
        {
            this.$root.openModalPlay('matches')
        },

        _getBackground()
        {
            const game = JSON.parse(JSON.stringify(this.filterVideoGame))
            let url

            while (game.length > 1)
            {
                const i = game.indexOf(3) > -1 ? game.indexOf(3) : (Math.random() < 0.5 ? 0 : 1)
                game.splice(i, 1)
            }

            const rid = game[0]

            switch (rid)
            {
            case 1:
                url = '/static/bg/bg-counter-strike-global-offensive.jpg'
                break
            case 2:
                url = '/static/bg/bg-street-fighter-v.jpg'
                break
            case 3:
                url = '/static/bg/bg-rocket-league.jpg'
                break
            default:
                url = '/static/bg/bg-empty.jpg'
            }

            return url
        },

        _getFilteredMatches(when)
        {
            const matchesJSON = JSON.parse(JSON.stringify(this.contentPage.list))
            const filterDate = this._getDateFilter(when)

            const days = []
            const matches = matchesJSON.filter(match =>
                match.dateStart >= filterDate[0]
                && match.dateStart <= filterDate[1]
                && this.filterVideoGame.includes(match.videoGameID))

            if (when === PAST)
            {
                matches.sort((a, b) => b.dateStart - a.dateStart)
            }
            else if (when === UPCOMING || when === TODAY)
            {
                matches.sort((a, b) => a.dateStart - b.dateStart)
            }

            if (matches.length > 0)
            {
                let lastDay
                for (const match of matches)
                {
                    const currentDay = dateFns.format(match.dateStart * 1000, 'DD[.]MM[.]YYYY')
                    if (!lastDay || lastDay.dateFormated[1] !== currentDay)
                    {
                        let week = (1 + dateFns.differenceInCalendarWeeks(match.dateStart * 1000, this.contentGlobal.week.first * 1000, {weekStartsOn: 1})).toString()
                        while (week.length < 2)
                        {
                            week = '0' + week
                        }

                        lastDay = {
                            dateFormated: [
                                dateFns.format(match.dateStart * 1000, 'dddd'),
                                currentDay,
                                this.contentGlobal.week.name.replace('{num}', week) /* ,
                                dateFns.getISOWeek(match.dateStart * 1000)*/
                            ],
                            // videoGame: this._getVideoGameFromID(match.videoGameID),
                            matches: [[], [], []]
                        }
                        days.push(lastDay)
                    }

                    lastDay.matches[match.videoGameID - 1].push(match)
                }
            }

            return days
        },

        filterMatches(when)
        {
            this.days.length = 0
            this.days = this._getFilteredMatches(when)

            if (this.contentPage.list.length > 0)
            {
                this.$nextTick(() => this.eventHub.$emit('bg-change', this._getBackground()))
                this.$nextTick(() => this.$emit('load', this))
            }
        },

        getVideoGameFromID(id)
        {
            return this.games.find(game => parseInt(game.id, 10) === id)
        },

        _onFilterDateToday()
        {
            this._filterDate = this._getDateFilter(TODAY)

            this.filterDay = TODAY
            this.filterMatches(this.filterDay)
        },

        _onFilterDatePast()
        {
            this._filterDate = this._getDateFilter(PAST)

            this.filterDay = PAST
            this.filterMatches(this.filterDay)
        },

        _onFilterDateUpcoming()
        {
            this._filterDate = this._getDateFilter(UPCOMING)

            this.filterDay = UPCOMING
            this.filterMatches(this.filterDay)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-matches/script.js